<template>
  <div>
    <match-info
      v-if="course.subject_group === 'vocabulary' || course.courseType === 'vocabulary'"
      :is-show-personage="true"
      :is-show-board="true" />
    <div class="quizzes-dialog dialog">
      <div class="eyeshield">
        <el-switch
          v-model="isOpenEyeshield"
          inactive-text="护眼模式"
          active-color="#5256e6" />
      </div>
      <div
        class="content"
        :class="{ 'eyeshield-color': isOpenEyeshield }">
        <div
          class="content"
          :class="{ 'eyeshield-color': isOpenEyeshield }">
          <div
            class="close"
            @click="onClose"
            ></div>
          <div class="title">{{quizData.navigation}}</div>
          <level-result
            v-if="scene === 3 && (this.type === 'level' || this.type === 'bdc_level')"
            :level-info="levelInfo"
            @close="onClose"
            @continue="continuePass" />
          <review-result
            v-if="scene === 3 && (this.type === 'active_review' || this.type === 'bdc_review')"
            :is-half="isHalf"
            :result="result"
            :spend-time="spendTime"
            @close="onClose"
            @continue="continueReview"
          />
          <div
            v-if="(type === 'active_review' || type === 'bdc_review') && scene === 1"
            class="pre-scene">
            <div class="pre-scene-main">
              <img
                class="review-image"
                src="https://vanthink.oss-cn-qingdao.aliyuncs.com/a229f9f27378c91750bfed46eb79ca1a.png" alt="">
              <div class="describe">
                <div class="scene-title course-name">{{course.name}}</div>
                <div class="scene-describe">{{unit.name}}</div>
              </div>
              <div class="scene-control">
                <div
                  class="btn btn-orange-square btn-circle"
                  @click="start"
                >开始复习</div>
              </div>
            </div>
          </div>
          <div
            class="pre-scene"
            v-if="(type === 'level' || type === 'bdc_level') && scene === 1">
            <div class="pre-scene-main">
              <img
                v-if="isBoss"
                src="https://vanthink.oss-cn-qingdao.aliyuncs.com/f781ebc294eb6993577dc62af63b2537.png" alt="">
              <img
                v-else
                src="https://vanthink.oss-cn-qingdao.aliyuncs.com/4088f5e81b5487eeaaad0fa2add2b302.png" alt="">
              <div class="describe">
                <template v-if="isBoss">
                  <div class="scene-title">Boss来袭</div>
                  <div class="scene-describe">鼓起勇气，迎战强敌！</div>
                </template>
                <div
                  v-else
                  class="scene-title">闯关完成后可获得积分奖励！</div>
              </div>
              <div class="scene-control">
                <div
                  class="btn btn-orange-square btn-circle"
                  @click="start('level')"
                >开始闯关</div>
                <div
                  class="btn btn-blue-square"
                  @click="onClose">暂不闯关</div>
              </div>
            </div>
          </div>
          <template v-if="course.type === 'BKW'">
            <van-bkw-dialog
              v-show="scene === 2"
              ref="dialog"
              :navigation="quizData.navigation"
              :is-exam-records="!!params.isExamRecords"
              :title="quizData.title"
              :subtitle="quizData.subtitle"
              :description="quizData.description"
              :type="quizData.type"
              :status="quizData.status"
              :learn-mode="type"
              :play-times="quizData.playTimes"
              :quizzes="quizzes"
              @close="onClose"
              @submit="submitQuizResult"
              @continue="handleContinue"
              @openCertificate="isShowCertificate = true"
            />
          </template>
          <template v-if="course.type === 'BDC'">
            <van-bdc-dialog
              v-show="scene === 2"
              ref="dialog"
              :navigation="quizData.navigation"
              :title="quizData.title"
              :course-id="course.id"
              :course="course"
              :unit-id="recordUnitId || unit.id"
              :quiz-type="quizData.type"
              :subtitle="quizData.subtitle"
              :is-scoring="quizData.isScoring"
              :description="quizData.description"
              :status="quizData.status"
              :is-exam="isExam"
              :book-mode="quizData.bookMode"
              :exam-type="params.mode"
              :quizzes="quizzes"
              @replay="replay"
              @close="onClose"
              @continue="handleContinue"
              @submit="submitQuizResult" />
          </template>
          <template v-if="course.type === 'YW'">
            <van-c-n-dialog
              v-show="scene === 2"
              ref="dialog"
              :navigation="quizData.navigation"
              :is-exam-records="!!params.isExamRecords"
              :title="quizData.title"
              :subtitle="quizData.subtitle"
              :description="quizData.description"
              :type="quizData.type"
              :learn-mode="type"
              :status="quizData.status"
              :play-times="quizData.playTimes"
              :quizzes="quizzes"
              :project-code="course.projectCode"
              @submit="submitQuizResult"
              @continue="handleContinue"
              @close="onClose"
              @openCertificate="isShowCertificate = true"
            />
          </template>
          <template v-if="isShowHkDialog">
            <van-hk-dialog
              v-show="scene === 2"
              :course="course"
              :quiz-data="quizData"
              :is-exam="isExam"
              :is-exam-records="!!params.isExamRecords"
              :exam-record-score="params.score"
              :is-fallible="isFallible"
              ref="dialog"
              @continue="handleContinue"
              @submit="submitQuizResult"
              @close="onClose"
              @openCertificate="isShowCertificate = true"
            />
          </template>
        </div>
      </div>
    </div>
    <van-certificate
      :info="certificateInfo"
      v-if="isShowCertificate"
      @close="isShowCertificate = false"
    />
  </div>
</template>

<script>
/* eslint-disable */
import englishApi from '@/api/graphql/englishCourse';
import chineseApi from  '@/api/graphql/chineseCourse';
import dsApi from '@/api/graphql/dsCourse';
import levelApi from '@/api/graphql/level';
import VanBkwDialog from '@/components/quizzes/bkw/Dialog.vue';
import VanBdcDialog from '@/components/quizzes/bdc/Dialog.vue';
import VanCNDialog from '@/components/quizzes/chinese/Dialog.vue';
import VanHkDialog from '@/components/quizzes/hk/new/Dialog.vue';
import LevelResult from '@/components/quizzes/LevelResult.vue';
import ReviewResult from '@/components/quizzes/ReviewResult.vue';
import MatchInfo from '@/components/match/MatchInfo.vue';
import VanCertificate from '@/views/learning/components/stageTest/StageTestCompleted.vue';
import utils from '@/services/utils';
import { Switch } from 'element-ui';

const SCENE = Object.freeze({
  ready: 1,
  playing: 2,
  finished: 3,
});

export default {
  props: {
    course: {
      type: Object,
      default: () => {},
    },
    unit: {
      type: Object,
      default: () => {},
    },
    module: {
      type: Object,
      default: () => {},
    },
    type: {
      type: String,
      default: '',
    },
    params: {
      type: Object,
      default: () => {},
    }
  },
  components: {
    VanBkwDialog,
    VanCNDialog,
    VanBdcDialog,
    VanHkDialog,
    ElSwitch: Switch,
    LevelResult,
    ReviewResult,
    MatchInfo,
    VanCertificate,
  },
  watch: {
    isOpenEyeshield() {
      if (this.isOpenEyeshield) {
        utils.storage('isOpenEyeshield', 1);
      } else {
        utils.storage('isOpenEyeshield', 0);
      }
    },
    type: {
      handler() {
        if (this.type === 'level'
          || this.type === 'bdc_level'
          || this.type === 'active_review'
          || this.type === 'bdc_review') {
          this.scene = SCENE.ready;
        } else {
          this.scene = SCENE.playing;
        }
      },
      immediate: true,
    },
  },
  computed: {
    quizzes() {
      if (this.quizData.quizzes) {
        // 冻结对象
        return this.quizData.quizzes.map(quiz => Object.freeze(quiz));
      }
      return [];
    },
    api() {
      const { projectCode } = this.course;
      if (projectCode === 'English' || projectCode === 'EnglishWord') {
        return englishApi;
      } else if (projectCode === 'DiShengHuiKao' || ['LS', 'DL', 'SW', 'SDSHK'].includes(projectCode)) {
        return dsApi;
      }
      return chineseApi;
    },
    isExam() {
      return this.quizData.type === 'online'
        || this.quizData.type === 'book_learn'
        || this.quizData.type === 'learn_before_test'
        || this.quizData.type === 'learn_after_test'
        || this.quizData.type === 'unit_dictation'
        || this.quizData.type === 'mock_exam'
        || this.quizData.type === 'test'
        || this.quizData.type === 'section_exam_affiliated'
        || this.quizData.type === 'section_exam'
        || this.quizData.type === 'drill'
        || this.quizData.type === 'fallible';
    },
    isBoss() {
      const { nextLevelInfo: { itemCode } } = this.levelInfo;
      if (itemCode === 'boss') {
        return true;
      } else if (this.params.levelCode === 'boss' && !itemCode) {
        return true;
      }
      return false;
    },
    isFallible() {
      return this.params.type === 'fallible';
    },
    isShowHkDialog() {
      return this.course.projectCode === 'DiShengHuiKao'|| ['LS', 'DL', 'SW', 'SDSHK'].includes(this.course.projectCode);
    },
  },
  data() {
    return {
      quizData: {},
      recordUnitId: 0,
      isOpenEyeshield: false,
      scene: SCENE.ready,
      levelInfo: {
        nextLevelInfo: {},
      },
      result: [],
      spendTime: 0,
      isHalf: false,
      isShowCertificate: false,
      certificateInfo: {},
    };
  },
  created() {
    this.getQuizzes();
    this.isOpenEyeshield = !!utils.storage('isOpenEyeshield');
  },
  methods: {
    onClose() {
      utils.confirm('是否要退出学习?').then(() => {
        const { projectCode } = this.course;
        if (projectCode === 'DiShengHuiKao') {
          this.onHkClose();
        } else {
          this.quizData = {};
          this.$emit('close');
        }
      });
    },
    onHkClose() {
      const hkDialog = this.$refs.dialog;

      const close = () => {
        this.quizData = {};
        this.$emit('close');
      };

      if (hkDialog && hkDialog.isScenePlaying) {
        if (hkDialog.isAutoSubmit) {
          hkDialog.submitResult({
            callback: () => {
              close();
            },
          });
        } else if (hkDialog.isMidwaySave) {
          utils.confirm('确定要退出考试吗？系统会保持您当前的进度，以便下次回来可以继续。', '提示', {
            showClose: false,
            closeOnClickModal: false,
          })
            .then(() => {
              hkDialog.submitResult({
                isBacktrack: true,
                callback: () => {
                  close();
                },
              });
            });
        } else {
          close();
        }
      } else {
        close();
      }
    },
    getQuizzes(callback) {
      this.api.getCourseData({
        courseId: this.course.id,
        unitId: this.unit.id,
        moduleId: this.module.id,
        type: this.type,
        projectCode: this.course.projectCode,
        ...this.params,
      }).then(({ englishCourseData, chineseCourseData, dsCourseData }) => {
        this.quizData = chineseCourseData || englishCourseData || dsCourseData;
        if (callback && typeof callback === 'function') {
          callback();
        }
      }).catch(({ code, message }) => {
        this.$refs.dialog.error({ code, message });
      });
    },
    submitQuizResult({
      data,
      seconds,
      callback,
      type,
      mode,
      isBacktrack,
      spend,
      isHalf,
    }) {
      const { star, nextLevelInfo: { itemCode, itemType } } = this.levelInfo;

      this.api.submitCourseResult({
        id: this.quizData.id,
        moduleId: this.module.id,
        quizzes: data,
        type: type || this.type,
        unitId: itemType || this.unit.id,
        courseId: this.course.id,
        seconds,
        spend,
        mode: this.params.mode || mode,
        levelCode: itemCode || this.params.levelCode,
        projectCode: this.params.projectCode,
        isBacktrack,
      })
        .then(({ englishCourseResult, chineseCourseResult, submitDsResult: dsCourseResult }) => {
          const result = englishCourseResult || chineseCourseResult || dsCourseResult;

          if (this.type === 'level' || this.type === 'bdc_level') {
            this.scene = SCENE.finished;
            if (result.star >= 1) {
              this.levelInfo = result;
            } else {
              this.levelInfo = {
                ...result,
                nextLevelInfo: this.levelInfo.nextLevelInfo,
              };
            }
            return;
          }

          if (this.type === 'bdc_review' || this.type === 'active_review') {
            this.scene = SCENE.finished;
            this.result = this.quizzes;
            this.spendTime = seconds;
            this.isHalf = isHalf;
            return;
          }

          if (this.type === 'stage') {
            const { name, schoolName } = utils.storage('account');
            this.certificateInfo = {
              seconds,
              count: result.wordCount,
              score: result.score,
              name,
              schoolName,
            };
          }

          if (callback) {
            callback(result);
          }
        }, (e) => {
          console.log(e);
        });
    },
    handleContinue(type, options) {
      switch (this.course.type) {
        case 'BDC':
          const { scene, res = {} } = options;
          this.handleWordCountinue(type, scene, res);
          break;
        case 'DS':
          this.handleDsContinue(options);
          break;
        default:
          this.hanleFreeCombination(type);
      }
    },
    handleWordCountinue(type, scene, res) {
      const params = {
        courseId: res.courseId || this.course.id,
        unitId: res.unitId || this.unit.id,
        type: type || this.course.type,
      };

      this.recordUnitId = res.unitId || 0;
      this.api.getCourseData(params).then(({ englishCourseData }) => {
        this.quizData = englishCourseData;
      });
    },
    // 自由组合
    hanleFreeCombination(type) {
      const params = {
        moduleId: this.module.id,
        type: type || this.quizData.type,
      };

      this.api.getCourseData(params).then(({ englishCourseData, chineseCourseData }) => {
        this.quizData = englishCourseData || chineseCourseData;
      });
    },
    // 史地生
    handleDsContinue(options) {
      const { callback } = options;
      const { course, ...params } = this.params;

      this.api
        .getCourseData(params)
        .then(({ dsCourseData }) => {
          this.quizData = dsCourseData;
          if (callback) {
            callback();
          }
        })
        .catch(({ code, message }) => {
          this.$refs.dialog.error({ code, message });
        });
    },
    replay({ quizzes, type }) {
      if (type === 'wrongs') {
        this.quizData = {
          id: this.course.id,
          type: 'learn_after_test',
          navigation: `${this.course.name}-错题再练`,
          title: '',
          subtitle: '',
          description: '',
          quizzes,
        };
        this.$refs.dialog.scene = 2;
      }
    },
    start(type) {
      if(type === 'level' || type === 'bdc_level') {
        levelApi.usedEnergyData().then(() => {
          this.scene = SCENE.playing;
          this.$refs.dialog.scene = SCENE.playing;
        })
      } else {
        this.scene = SCENE.playing;
        this.$refs.dialog.scene = SCENE.playing;
      }
    },
    continuePass() {
      const { nextLevelInfo: { itemCode, itemType } } = this.levelInfo;

      this.api.getCourseData({
        courseId: this.course.id,
        type: this.type,
        projectCode: this.course.projectCode,
        unitId: itemType || this.unit.id,
        levelCode: itemCode || this.params.levelCode,
        mode: this.params.mode,
      }).then(({ englishCourseData, chineseCourseData, dsCourseData }) => {
        this.quizData = chineseCourseData || englishCourseData || dsCourseData;
        this.scene = SCENE.playing;
        this.$nextTick(() => {
          this.$refs.dialog.scene = SCENE.playing;
        })
      }).catch(({ code, message }) => {
        if (this.$refs[this.course.type]) {
          this.$refs[this.course.type].error({ code, message });
        }
      });
    },
    continueReview() {
      this.scene = SCENE.playing;
      if (this.type === 'bdc_review') {
        this.$refs.dialog.$refs.controller.$refs.countdown.start()
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "@/styles/common/dialog.scss";
  .quizzes-dialog {
    width: 80vw;
    height: 90vh;
    .content {
      display: flex;
      flex-direction: column;
      .pre-scene {
        flex: 1;
        background: url('https://vanthink.oss-cn-qingdao.aliyuncs.com/697e31076eee80289ff361035fa4367e.png')
          no-repeat center center / cover;
        .pre-scene-main {
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          text-align: center;
          img {
            width: 30%;
          }
          .review-image {
            width: 15%;
          }
          .course-name {
            margin-top: 2vh;
            margin-bottom: 0;
          }
          .scene-title {
            margin-bottom: 2vh;
            font-size: 3.5vh;
            font-weight: 700;
          }
          .scene-describe {
            font-size: 3vh;
          }
          .scene-control {
            margin: 5vh 0;
            display: flex;
            justify-content: center;
            width: 100%;
            .btn {
              margin: 0 4vh;
              width: 20vh;
              height: 6vh;
              font-size: 2.5vh;
              border-radius: 30px;
            }
          }
        }
      }
      /deep/ .quizzes-wrapper {
        position: relative;
        flex: 1;
        border-radius: 24px;
        .component-wrap {
          border-radius: 24px;
        }
        .exam-detail {
          color: #333;
          background: #fff;
        }
        .exam-control {
          background: #fff;
        }
      }
    }
    .eyeshield-color {
      /deep/ .hk-dialog {
        .footer-bar {
          background: rgb(233, 235, 254)!important;
        }
      }
      /deep/ .quizzes-wrapper {
        .component-wrap, .control-bar-u, .exam, .article-exam-wrap {
          color: #333;
          background: rgb(233, 235, 254)!important;
          border-radius: 24px;
          .answer-card {
            background: rgb(233, 235, 254)!important;
          }
          .text-input {
            background: #fff;
          }
          .dcpx-container .main .user-answer {
            background: #fff!important;
            span {
              background: #fff!important;
            };
          }
          .sk-container {
            .input {
              background: #fff;
            }
          }
        }
        .answer-card {
          background: rgb(233, 235, 254)!important;
          .detail {
            .item {
              border-bottom: 1px solid rgb(205, 203, 203);
            }
          }
        }
        .exam-detail {
          color: #333;
          background: rgb(233, 235, 254)!important;
          .quizze {
            border-bottom: 1px solid rgb(205, 203, 203);
          }
        }
        .exam-control {
          background: rgb(233, 235, 254)!important;
        }
        .exam {
          .dctx-container {
            .text-input {
              background: transparent;
            }
          }
        }
      }
    }
    .eyeshield {
      position: absolute;
      top: 25px;
      right: 100px;
      z-index: 1;
      /deep/ .el-switch {
        .el-switch__label--left {
          color: #fff;
        }
      }
    }
  }
</style>
